export const userList = 'admin/user_list';

export const userCreation = 'admins/create_user';

export const userUpdate='admins/update_user';

export const updateConsultant='admins/update_consultant';

export const deleteConsultant = "admins/delete_user";

export const languagesList = 'language/list';

export const addLanguage='language/add_language';

export const servicesList = 'service/list';

export const addService='service/add_service';

export const expertiseList = 'expertise/list';

export const addExpertise='expertise/add_expertises';

export const rechargeList = 'admin/subscriptions_list';

export const addRecharge='recharge/create';

export const credentialsList = 'admin/credentials_list';

export const addCredentials='admin/create_credentials';

// Real backend route is POST admin/update_credentials (the old
// application/update_credential_status group does not exist).
export const updateCredentials='admin/update_credentials'

export const  consultant= 'consultant/list';

export const StatusConsultant='admins/approved';

export const consultant_Active='admins/permission';

export const AdminList='admins/list';

export const UpdateAdmin='admins/update_admin';

export  const recording='admins/pending_recordings_list';

export const uploadImage='upload_file/image'; 

export const updateRecordingStatus='admins/approve_recording';

export const getConsultantBalance='admins/consultants_by_balance';

export const getBanks='admins/consultants_by_pending_bank_details'

export const approveBank='admins/approve_partner_bank_details';

export const postCredentials='consultant/fund_transfer';

export const Admin='admins/create';

export const subAdmin='admins/sub_admins_list';

export const updateAdminStatus='admins/change_status';

export const updateConsultantAudio='voice_type/update_status';

export const PlanFetch='recharge/subscription_plans_list?name=Subscriptions';

export const otp='session/login';

export const rechargeDelete='admin/delete_plan';

export const getConsultantUserRecharge='admins/update_balance';

export const EditDetails = 'expertise/update';

export const EditServiceDetails = 'service/update';

export const updateLanguageDetail = 'language/update';

export const updateCredentialsDetail = 'admin/update_credentials';

export const userStatus = 'admins/permission';

// Real Premika user activate/deactivate. Deactivate = soft-delete (sets
// deleted_at); activate = restore. The legacy admins/permission route 404s.
export const deleteUserUri = 'admin/delete_user';
export const restoreUserUri = 'admin/restore_user';

export const DeleteApi = 'admins/delete_entity';

export const updatePassword='admins/change_password';

export const updateAdminPassword='admins/reset_password';

export const userdelete = "user/delete_account";

export const dashboarduri = "analytics/recent_transactions";

export const statusuri = "analytics/overall";

export const ExcelFile = "admins/update_fund_details"

export const update_recharge = "recharge/update" ;

export const addSubscription = "admin/create_plan" ;